import React from "react";

const Loader = () => {
  return (
    <div className="spinner-border text-dark" role="status">
      <span className="sr-only" style={{ position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" }}>
        Loading...
      </span>
    </div>
  );
};

export default Loader;
